/** Whether or not touch gestures are supported by the browser. */
export var touch = 'ontouchstart' in window ||
    (navigator.msMaxTouchPoints ? true : false) ||
    false;



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/_modules/dragevents/_support.js
// module id = 51
// module chunks = 0